module.exports = __webpack_public_path__ + "static/img/kr-847-345-75bb.f225849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kr-847-345-75bb.jpg
// module id = Zxik
// module chunks = 0